module.exports = __webpack_public_path__ + "static/media/rs.7bb204a0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/rs.svg
// module id = 2198
// module chunks = 0